import Beam from './beam.svg?react';
import Column from './column.svg?react';
import Cooling from './cooling.svg?react';
import Heating from './heating.svg?react';
import Labour from './labour.svg?react';
import Other from './other.svg?react';
import Slab from './slab.svg?react';
import Ventilation from './ventilation.svg?react';
import Wall from './wall.svg?react';
import Windows from './windows.svg?react';
import Ceramics from './ceramics.svg?react';
import Concrete from './concrete.svg?react';
import Energy from './energy.svg?react';
import Gypsum from './gypsum.svg?react';
import Insulation from './insulation.svg?react';
import Metal from './metal.svg?react';
import OtherProduct from './otherproduct.svg?react';
import UnknownProduct from './unknownproduct.svg?react';
import Wood from './wood.svg?react';
import Solar from './solar.svg?react';
import Facades from './facades.svg?react';
import Floors from './floors.svg?react';
import Foundation from './foundation.svg?react';
import Installations from './installations.svg?react';
import Roof from './roof.svg?react';
import Walls from './walls.svg?react';

export const CategoryIcons = {
  Beam,
  Column,
  Cooling,
  Heating,
  Labour,
  Other,
  Slab,
  Ventilation,
  Wall,
  Windows,
  Ceramics,
  Concrete,
  Energy,
  Gypsum,
  Insulation,
  Metal,
  OtherProduct,
  UnknownProduct,
  Wood,
  Solar,
  Facades,
  Floors,
  Foundation,
  Installations,
  Roof,
  Walls,
};
